import { Checkbox, Space, Switch, Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ExtraPanel = ({
  disabled,
  onChange,
  loading,
  isApplied,
  onChangeCheckbox,
  action,
  checked,
}) => {
  const { t } = useTranslation()

  const renderDisabled = () => {
    if (action === 'apply') {
      return isApplied
    } else if (action === 'unapply') {
      return !isApplied
    }
    return false
  }

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      role="button"
      tabIndex={0}
      onTouchStart={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation()
        }
      }}
    >
      <Tooltip title={disabled ? t('PLANNING_FORMULA_SAVE_DATA_TOOLTIP_TITLE') : ''}>
        <Space direction="horizontal">
          <Switch
            checkedChildren={t('FIELD_APPLIED')}
            unCheckedChildren={t('FIELD_UNAPPLIED')}
            disabled={disabled}
            onChange={onChange}
            loading={loading}
            checked={isApplied}
          />
          <Checkbox
            onChange={onChangeCheckbox}
            checked={checked}
            disabled={renderDisabled() || !action}
          />
        </Space>
      </Tooltip>
    </div>
  )
}

ExtraPanel.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  isApplied: PropTypes.bool,
  onChangeCheckbox: PropTypes.func,
  action: PropTypes.string,
  checked: PropTypes.bool,
}

export default ExtraPanel
